<div class="container">
  <image-cropper [imageBase64]="this.base64" [aspectRatio]="1" (imageCropped)="imageCropped($event)"> </image-cropper>

  <button class="close-button" (click)="onClose()">Close</button>
  <button class="submit-button" (click)="onSubmit()">Crop</button>
</div>
